const envApiBase = process.env.REACT_APP_API_URL?.trim();

function normalizeApiBase(base) {
  if (!base) return '/api';

  const trimmed = base.trim().replace(/\/$/, '');
  if (!trimmed) return '/api';

  // If only an origin is provided (https://example.com), use /api automatically.
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const parsed = new URL(trimmed);
      if (!parsed.pathname || parsed.pathname === '/') {
        parsed.pathname = '/api';
        return parsed.toString().replace(/\/$/, '');
      }
    } catch (error) {
      // Invalid URL in env var, keep value as-is so diagnostics can surface it.
    }
  }

  return trimmed;
}

const API_BASE = normalizeApiBase(envApiBase);

if (typeof window !== 'undefined' && window.location.protocol === 'https:' && API_BASE.startsWith('http://')) {
  console.error(
    `[API_BASE] Insecure API URL "${API_BASE}" from HTTPS page "${window.location.origin}". ` +
    'Set REACT_APP_API_URL to an https:// URL to avoid browser blocked requests.'
  );
}

export default API_BASE;
